$( document ).ready(function() {
 var width_window = $( window ).width();
  if( width_window < 676) {
    $(".new_des").removeClass("page-width");
  }
//  $.get("//ipinfo.io", function(e){
// var locat_area;
//  locat_area =e.country;
//   if (locat_area == 'IN'){
//      window.location.replace("https://campussutra.com/");
// }
// },"jsonp"); 
     $(document).on('click', '.sidebar_widget .widget-title', function () {
      $(this).parents(".sidebar_widget").find(".widget-content").toggle("Active");
      $(this).parents(".sidebar_widget").find("ul.clrFl").toggle("Active");
       $(this).toggleClass("contentD");
   });
  if ($('.empty-page-content')[0]) {
  window.location.replace("https://campussutra.ca/");
}  
  // Nav Upper Tab
$('#tabs-nav li:first-child').addClass('Active_show');
$('.tab-content_header').hide();
$('.tab-content_header:first').show();

// Click function
$('#tabs-nav li').click(function(){
  $('#tabs-nav li').removeClass('Active_show');
  $(this).addClass('Active_show');
  $('.tab-content_header').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});
   // Nav Upper Tab
   // Nav Upper Tab for Accessories
  $('#tabs-nav_under li:first-child').addClass('Active_under');
$('.tab-content_under_access').hide();
$('.tab-content_under_access:first').show();

// Click function
$('#tabs-nav_under li').click(function(){
  $('#tabs-nav_under li').removeClass('Active_under');
  $(this).addClass('Active_under');
  $('.tab-content_under_access').hide();
  
  var activeTab_under = $(this).find('a').attr('href');
  $(activeTab_under).fadeIn();
  return false;
});
    // Nav Upper Tab for Accessories
    // Nav Upper Tab for Apparel
  $('#tabs-nav_under_apparel li:first-child').addClass('Active_under');
$('.tab-content_under').hide();
$('.tab-content_under:first').show();

// Click function
$('#tabs-nav_under_apparel li').click(function(){
  $('#tabs-nav_under_apparel li').removeClass('Active_under');
  $(this).addClass('Active_under');
  $('.tab-content_under').hide();
  
  var activeTab_under_apparel = $(this).find('a').attr('href');
  $(activeTab_under_apparel).fadeIn();
  return false;
});
    // Nav Upper Tab for Apparel
   // Nav Upper Tab for Jeweller
  $('#tabs-nav_under_jeweller li:first-child').addClass('Active_under');
$('.tab-content_under_jeweller').hide();
$('.tab-content_under_jeweller:first').show();

// Click function
$('#tabs-nav_under_jeweller li').click(function(){
  $('#tabs-nav_under_jeweller li').removeClass('Active_under');
  $(this).addClass('Active_under');
  $('.tab-content_under_jeweller').hide();
  
  var activeTab_under_jeweller = $(this).find('a').attr('href');
  $(activeTab_under_jeweller).fadeIn();
  return false;
});
    // Nav Upper Tab for Jeweller
   // Nav Upper Tab for Decor
  $('#tabs-nav_under_decor li:first-child').addClass('Active_under');
$('.tab-content_under_decor').hide();
$('.tab-content_under_decor:first').show();

// Click function
$('#tabs-nav_under_decor li').click(function(){
  $('#tabs-nav_under_decor li').removeClass('Active_under');
  $(this).addClass('Active_under');
  $('.tab-content_under_decor').hide();
  
  var activeTab_under_decor = $(this).find('a').attr('href');
  $(activeTab_under_decor).fadeIn();
  return false;
});
    // Nav Upper Tab for Decor
   // Size Select in PDP
var sel_size = $("label.pos-Size").attr("data-value-new");
var sel_val = $("label.pos-Size").val();
if( sel_size != sel_val){
  $(".product-action button").addClass("active-size-select");
   $("a.Select-size-dummy").addClass("active"); $("a.Select-size-dummy").addClass("active");
   // $(".stickyCart").addClass("overlay-sel");
   $(".sel_sticky").addClass("active-sel");
   $(".stickyCart form").addClass("select_op");
  $("a.stick_pl_btn").addClass("active_st");
   $(".sel_stic_btn").css("display","none");
   $(".selectedst_view").addClass("active_stoper");
  }
   $(document).on('click', '.show-Size .swatch-element', function () {
  $(".product-action button").removeClass("active-size-select");
      $("a.view_your_cart_dummy").removeClass('new_view_cart_show'); 
      $('.product-form__cart-submit').removeClass('new_myn');
       $('.quickshop-cart').removeClass('new_myn');
     $("a.Select-size-dummy").removeClass("active");
      $(".slVariant").show();
     $("a.Select-size-dummy_2").addClass("active_qui");
        $(".sel_qui").addClass("act_se");
     $(".show-Size .sel_msg").removeClass("active_sz");
     $(".show-SIZE .sel_msg").removeClass("active_sz");
    $(".show-size .sel_msg").removeClass("active_sz");
   });
    $(document).on('click', 'li.vrOpt', function () {
      $("a.stick_pl_btn").removeClass("active_st");
        $(".sel_stic_btn").css("display","block");
    }); 
  var sel_size_1 = $("label.pos-SIZE").attr("data-value-new");
var sel_val_1 = $("label.pos-SIZE").val();
if( sel_size_1 != sel_val_1){
  $(".product-action button").addClass("active-size-select");
   $("a.Select-size-dummy").addClass("active"); $("a.Select-size-dummy").addClass("active");
   // $(".stickyCart").addClass("overlay-sel");
   $(".sel_sticky").addClass("active-sel");
   $(".stickyCart form").addClass("select_op");
  $("a.stick_pl_btn").addClass("active_st");
   $(".sel_stic_btn").css("display","none");
   $(".selectedst_view").addClass("active_stoper");
  }
   $(document).on('click', '.show-SIZE .swatch-element', function () {
  $(".product-action button").removeClass("active-size-select");
     $("a.Select-size-dummy").removeClass("active");
      $("a.view_your_cart_dummy").removeClass('new_view_cart_show'); 
      $('.product-form__cart-submit').removeClass('new_myn');
      $('.quickshop-cart').removeClass('new_myn');
      $(".slVariant").show();
     $("a.Select-size-dummy_2").addClass("active_qui");
        $(".sel_qui").addClass("act_se");
      $(".show-Size .sel_msg").removeClass("active_sz");
     $(".show-SIZE .sel_msg").removeClass("active_sz");
    $(".show-size .sel_msg").removeClass("active_sz");
   });
    $(document).on('click', 'li.vrOpt', function () {
      $("a.stick_pl_btn").removeClass("active_st");
        $(".sel_stic_btn").css("display","block");
    }); 
   // Size Select in PDP
  // Size Select Msg In 
  $(document).on('click', '.sel_btn_click', function () {
    $(".show-Size .sel_msg").addClass("active_sz");
     $(".show-SIZE .sel_msg").addClass("active_sz");
    $(".show-size .sel_msg").addClass("active_sz");
    $(".selectedst_view").addClass("active_hy");
     $(".show-Size").addClass("face_size");
      $(".show-SIZE").addClass("face_size");
      $(".show-size").addClass("face_size");
});
  $(document).on('click', '.show-Size .swatch-element:not(.soldout)', function () {
     $("a.stick_pl_btn").removeClass("active_st");
        $(".sel_stic_btn").css("display","block");
  var iuy = $(this).attr('data-inv');
     $('ul li.vrOpt').each(function(){
		if(iuy == $(this).attr('data-val')){
   $(this).trigger('click'); 
        }
  });
  });
   $(document).on('click', '.stick_pl_btn.sel_btn_click', function () {
      var ghyuj= $(".show-Size").html();
     $(".add_size_on_click_html").html(ghyuj);
      $(".add_size_on_click").addClass('act_op');
     // $(".stick_pl_btn.sel_btn_click").removeClass("active_st");
   });
   $(document).on('click', '.add_size_on_click_html .swatch-element', function () {
          $('.add_size_on_click_html .swatch-element').removeClass("act_swa");
     $(this).addClass("act_swa");
      $(".done_cli").addClass('active_rt');
   });
   $(document).on('click', '.done_cli', function () {
      $(".add_size_on_click").removeClass('act_op');
   });
   $(document).on('click', '.done_cli.active_rt', function () {
       $(".add_size_on_click").removeClass('act_op');
      $(".btn.sel_stic_btn").trigger('click'); 
   });
   $(document).on('click', '.close_div_sel', function () {
       $(".add_size_on_click").removeClass('act_op');
    //   $(".stick_pl_btn").addClass('active_st');
    // $(".sel_stic_btn.active_pt").hide();
   });
    $(document).on('click touchend', '.product-form__cart-submit', function(i){
       if (i.preventDefault(), "disabled" != $(this).attr("disabled")){
    $('.product-form__cart-submit').addClass('new_myn');
         $("a.view_your_cart_dummy").addClass('new_view_cart_show');
         $(".sel_stic_btn.active_pt").addClass("new_myn");
          $(".add_size_on_click").removeClass('act_op');
       }
   });
    $(document).on('click', '.quickshop-cart', function(i){
             $(this).addClass('new_myn');
            $("a.view_your_cart_dummy").addClass('new_view_cart_show');  
            
});
   $(document).on('click', 'a.view_your_cart_dummy', function () {
     $("a.header-cart").trigger('click');
   });
//Shipping Information 
  var query_url=$(".shipping_information").attr("data-ship");
  var url_ship = window.location.href+"?";
  var url_ship_quer = url_ship+query_url;
  var url_spli_new = url_ship_quer.split('?')[1];
  if( url_spli_new == " "){
     $('.shipping_information').css('display','none');
  }
  else{
    $('.shipping_information[data-ship="'+url_spli_new+'"]').css('display','block');
  }
 $(".order_id_submit").click(function(e){
     e.preventDefault();
   var texInputValue = $('#order_id').val();
      window.location.href="/pages/shipping-information?"+texInputValue;
 });
//Shipping Information 
});